import type { IKeybinding } from "../../../../platform/keybinding/common/keybindingService.js";

/** Input already owned by a managed editor service must reach that service before host-page capture. */
export function shouldPassManagedInput(
    eventType: string,
    binding: Pick<IKeybinding, "allowOnCanvas"> | undefined,
    commandCanExecute: boolean,
): boolean {
    if (eventType === "dblclick") return true;
    return eventType === "keydown" && binding?.allowOnCanvas === true && commandCanExecute;
}
